// extracted by mini-css-extract-plugin
export var isActive = "Link-module--isActive--10732";
export var revertColors = "Link-module--revertColors--354d1";